import {
  Avatar,
  Box,
  Grid,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import ActividadesExtcurView from '../../../actividades_extcur/ActividadesExtcurView';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import DireccionesView from '../../../direcciones/DireccionesView';
import TelefonosView from '../../../telefonos/TelefonosView';
import UsuEntPerfilesView from '../../usu_ent_perfiles/UsuEntPerfilesView';
import UsuProfesionesView from '../../usu_profesiones/UsuProfesionesView';
import FormUsuPerfilComponent from '../components/FormUsuPerfil';
import FormUsuarioComponent from '../components/FormUsuario';
import CarnetUsuariosPanel from './components/CarnetUsuariosPanel';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  const templateStore = Redux.useSelector((state) => state.template);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: 3,
            width: templateStore.settings.openSidebar ? '60vw' : '80vw',
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const PanelUsuariosView = () => {
  const loginStore = Redux.useSelector((state) => state.login);
  const usuariosStore = Redux.useSelector((state) => state.usuarios);

  const [value, setValue] = React.useState(0);

  const activo = usuariosStore.activo;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const views = [
    {
      name: 'Información',
      view: <FormUsuPerfilComponent />,
    },
    {
      name: 'Usuario',
      view: <FormUsuarioComponent isUsuarios={false} />,
    },
    {
      name: 'Teléfonos',
      view: <TelefonosView idUsuario={activo.id} />,
    },
    {
      name: 'Direcciones',
      view: <DireccionesView idUsuario={activo.id} />,
    },
    {
      name: 'Actividades Extracurriculares',
      view: <ActividadesExtcurView />,
    },
  ];

  if (loginStore.isRoot) {
    views.push(
      ...[
        {
          name: 'Carnet',
          view: <CarnetUsuariosPanel />,
        },
      ],
    );
  }

  if (loginStore.isRoot || loginStore.isAdmin) {
    views.push(
      ...[
        {
          name: 'Perfiles',
          view: <UsuEntPerfilesView />,
        },
      ],
    );
  }

  views.push(
    ...[
      {
        name: 'Profesiones',
        view: <UsuProfesionesView />,
      },
    ],
  );

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Paper elevation={4} sx={{ p: 1 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            spacing={3}
          >
            <Avatar
              alt={activo.perfil.pnombre}
              sx={{ width: 50, height: 50 }}
              src={getFilesArchivos(activo.perfil.avatar)}
            />
            <Typography>
              <strong style={{ fontSize: '10pt' }}>Identificación</strong>
              <br />
              {activo.perfil.tipoDni}-{activo.perfil.dni}
            </Typography>
            <Typography>
              <strong style={{ fontSize: '10pt' }}>Nombre y apellido</strong>
              <br />
              {activo.perfil.pnombre} {activo.perfil.snombre}{' '}
              {activo.perfil.papellido} {activo.perfil.sapellido}
            </Typography>
            <Typography>
              <strong style={{ fontSize: '10pt' }}>Correo electrónico</strong>
              <br />
              {activo.correo}
            </Typography>
          </Stack>
        </Paper>
      </Grid>
      <Grid item md={12}>
        <Paper elevation={4}>
          <Box sx={{ flexGrow: 1, display: 'flex' }}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Ppanel usuario"
              sx={{ borderRight: 1, borderColor: 'divider' }}
            >
              {views.map((e, i) => {
                return (
                  e && (
                    <Tab
                      key={`tabs_${i}`}
                      label={e.name}
                      sx={{
                        width: '200px',
                      }}
                      {...a11yProps(i)}
                    />
                  )
                );
              })}
            </Tabs>
            {views.map((e, i) => {
              return (
                e && (
                  <TabPanel value={value} key={i} index={i} sx={{ p: 0 }}>
                    {e.view}
                  </TabPanel>
                )
              );
            })}
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PanelUsuariosView;
